import axios from "../axios";

export type ResourceType = "PATH" | "PARAMETER" | "HEADER" | "IP" | "PORT" | "FILE" | "OTHER";
export type ResourceStatus = "IN_SCOPE" | "OUT_OF_SCOPE" | "TESTED" | "PENDING" | "EXCLUDED";

export interface CreateResourceInput {
    asset_id: string;
    target_id: string;
    value: string;
    resource_type: ResourceType;
    status?: ResourceStatus;
    http_method?: string;
    notes?: string;
    metadata?: Record<string, unknown>;
    program_id?: number;
}

export interface TargetResource {
    resource_id: number;
    target_id: string;
    value: string;
    resource_type: ResourceType;
    status: ResourceStatus;
    http_method?: string | null;
    notes?: string | null;
    metadata?: any;
    discovery_method: "MANUAL" | "IMPORT" | "PENTESTER" | "AI_DISCOVERY";
    created_by?: number;
    createdAt: string;
    updatedAt: string;
}

const BASE_URL = "/assets";

/**
 * Create a new resource for a target
 */
export const createTargetResource = async (
    data: CreateResourceInput
): Promise<TargetResource> => {
    try {
        const { asset_id, target_id, ...payload } = data;
        const response = await axios.post(`${BASE_URL}/${asset_id}/targets/${target_id}/resources`, payload);
        return response.data;
    } catch (error) {
        console.error("Error creating target resource:", error);
        throw error;
    }
};
